module.exports = __webpack_public_path__ + "static/media/home-head-mobo.bad4cbc1.png";